import { useState, useEffect, useCallback } from "react";
import type { DeviceCapabilitiesResponse } from "@centro-cirurgico/contracts";
import { getDeviceCapabilities } from "../utils/api";

interface UseCapabilitiesResult {
  data: DeviceCapabilitiesResponse | null;
  loading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export function useCapabilities(enabled = true): UseCapabilitiesResult {
  const [data, setData] = useState<DeviceCapabilitiesResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchCapabilities = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getDeviceCapabilities();
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err : new Error("Erro desconhecido"));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }
    fetchCapabilities();
  }, [enabled, fetchCapabilities]);

  return { data, loading, error, refetch: fetchCapabilities };
}

export function hasFacialCapability(
  capabilities: DeviceCapabilitiesResponse["capabilities"] | undefined
): boolean {
  if (!capabilities) return false;
  return capabilities.includes("facial-validation");
}
